function Packages() {
  return (
    <div className="page-content">
      <section className="page-hero">
        <div className="page-hero-content">
          <h1 className="page-title">Travel Packages</h1>
          <p className="page-subtitle">Discover our carefully crafted travel packages for every budget and preference</p>
        </div>
      </section>

      <section className="packages-section">
        <div className="features-container">
          <div className="packages-grid">
            <div className="package-card">
              <div className="package-image">
                <img src="https://images.unsplash.com/photo-1506905925346-21bda4d32df4?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80" alt="European Adventure" />
                <div className="package-price">₹2,49,900</div>
              </div>
              <div className="package-content">
                <h3 className="package-title">European Adventure</h3>
                <p className="package-duration">14 Days • 7 Countries</p>
                <p className="package-description">
                  Explore the best of Europe with visits to Paris, Rome, Barcelona, Amsterdam, 
                  Prague, Vienna, and Budapest. Includes flights, hotels, and guided tours.
                </p>
                <ul className="package-features">
                  <li>✈️ Round-trip flights included</li>
                  <li>🏨 4-star hotels</li>
                  <li>🍽️ Daily breakfast & 5 dinners</li>
                  <li>👨‍🏫 Professional tour guide</li>
                </ul>
                <button className="package-btn">Book Now</button>
              </div>
            </div>

            <div className="package-card featured">
              <div className="package-badge">Most Popular</div>
              <div className="package-image">
                <img src="https://images.unsplash.com/photo-1552550049-db097c9480d1?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80" alt="Asian Discovery" />
                <div className="package-price">₹1,82,900</div>
              </div>
              <div className="package-content">
                <h3 className="package-title">Asian Discovery</h3>
                <p className="package-duration">12 Days • 4 Countries</p>
                <p className="package-description">
                  Experience the magic of Asia with stops in Tokyo, Bangkok, Singapore, and Bali. 
                  Perfect blend of culture, adventure, and relaxation.
                </p>
                <ul className="package-features">
                  <li>✈️ Round-trip flights included</li>
                  <li>🏨 Luxury resorts & hotels</li>
                  <li>🍜 Cultural dining experiences</li>
                  <li>🎋 Temple & cultural site visits</li>
                </ul>
                <button className="package-btn">Book Now</button>
              </div>
            </div>

            <div className="package-card">
              <div className="package-image">
                <img src="https://images.unsplash.com/photo-1516426122078-c23e76319801?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80" alt="African Safari" />
                <div className="package-price">₹3,16,500</div>
              </div>
              <div className="package-content">
                <h3 className="package-title">African Safari</h3>
                <p className="package-duration">10 Days • Kenya & Tanzania</p>
                <p className="package-description">
                  Witness the Great Migration in Serengeti, explore Ngorongoro Crater, 
                  and experience authentic African culture with luxury safari lodges.
                </p>
                <ul className="package-features">
                  <li>🦁 Game drives & safari tours</li>
                  <li>🏕️ Luxury safari lodges</li>
                  <li>🥘 All meals included</li>
                  <li>📷 Photography workshops</li>
                </ul>
                <button className="package-btn">Book Now</button>
              </div>
            </div>

            <div className="package-card">
              <div className="package-image">
                <img src="https://images.unsplash.com/photo-1544551763-46a013bb70d5?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80" alt="South American Explorer" />
                <div className="package-price">₹2,16,500</div>
              </div>
              <div className="package-content">
                <h3 className="package-title">South American Explorer</h3>
                <p className="package-duration">15 Days • 5 Countries</p>
                <p className="package-description">
                  From Machu Picchu to Rio de Janeiro, discover the wonders of South America 
                  including Peru, Bolivia, Chile, Argentina, and Brazil.
                </p>
                <ul className="package-features">
                  <li>🏔️ Machu Picchu trek</li>
                  <li>🏨 Boutique hotels</li>
                  <li>🍷 Wine tasting experiences</li>
                  <li>🎭 Cultural performances</li>
                </ul>
                <button className="package-btn">Book Now</button>
              </div>
            </div>

            <div className="package-card">
              <div className="package-image">
                <img src="https://images.unsplash.com/photo-1506197603052-3cc9c3a201bd?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80" alt="Mediterranean Cruise" />
                <div className="package-price">₹1,58,200</div>
              </div>
              <div className="package-content">
                <h3 className="package-title">Mediterranean Cruise</h3>
                <p className="package-duration">8 Days • 6 Ports</p>
                <p className="package-description">
                  Sail the Mediterranean with stops in Barcelona, Monaco, Rome, Naples, 
                  Santorini, and Mykonos aboard a luxury cruise ship.
                </p>
                <ul className="package-features">
                  <li>🚢 Luxury cruise ship</li>
                  <li>🍽️ All meals & entertainment</li>
                  <li>🏖️ Beach excursions</li>
                  <li>🎪 Onboard activities</li>
                </ul>
                <button className="package-btn">Book Now</button>
              </div>
            </div>

            <div className="package-card">
              <div className="package-image">
                <img src="https://images.unsplash.com/photo-1539650116574-75c0c6d73c6e?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80" alt="Australian Outback" />
                <div className="package-price">₹2,74,900</div>
              </div>
              <div className="package-content">
                <h3 className="package-title">Australian Outback</h3>
                <p className="package-duration">11 Days • Sydney to Perth</p>
                <p className="package-description">
                  Experience the rugged beauty of Australia from Sydney Opera House 
                  to Uluru, with stops in Melbourne, Adelaide, and the Great Ocean Road.
                </p>
                <ul className="package-features">
                  <li>🏨 Premium accommodations</li>
                  <li>🚌 Luxury coach transport</li>
                  <li>🦘 Wildlife encounters</li>
                  <li>🍷 Wine region tours</li>
                </ul>
                <button className="package-btn">Book Now</button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="package-benefits">
        <div className="features-container">
          <h2 className="features-title">What's Included in Every Package</h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">✈️</div>
              <h3 className="feature-title">Flights & Transport</h3>
              <p className="feature-description">
                All domestic and international flights, plus ground transportation 
                throughout your journey.
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🏨</div>
              <h3 className="feature-title">Premium Accommodation</h3>
              <p className="feature-description">
                Hand-picked hotels and resorts that offer comfort, luxury, 
                and authentic local experiences.
              </p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">👨‍🏫</div>
              <h3 className="feature-title">Expert Guides</h3>
              <p className="feature-description">
                Professional local guides who bring destinations to life with 
                insider knowledge and fascinating stories.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Packages;